import { render, staticRenderFns } from "./SLADoc.vue?vue&type=template&id=25f8f00c&scoped=true&"
import script from "./SLADoc.vue?vue&type=script&lang=js&"
export * from "./SLADoc.vue?vue&type=script&lang=js&"
import style0 from "./SLADoc.vue?vue&type=style&index=0&id=25f8f00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8f00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f8f00c')) {
      api.createRecord('25f8f00c', component.options)
    } else {
      api.reload('25f8f00c', component.options)
    }
    module.hot.accept("./SLADoc.vue?vue&type=template&id=25f8f00c&scoped=true&", function () {
      api.rerender('25f8f00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/workspace/prekickoff/SLADoc.vue"
export default component.exports